export default "__VITE_ASSET__DOJrvXbr__"